
export function getQueryStringValue(name, url = window.location.href) {
    name = name.replace(/[[]]/g, "\\$&");

    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
    const results = regex.exec(url);

    if (!results) {
        return null;
    }
    if (!results[2]) {
        return "";
    }

    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function getUrlParameters() {
    let url = window.location.href;
    let searchString = url.substring(url.indexOf("?") + 1, url.length);
    let parameterStrings = searchString.split("&");

    let urlParametersMap = {};
    parameterStrings.forEach((parameterString) => {
        let parameterArray = parameterString.split("=");
        urlParametersMap[parameterArray[0]] = parameterArray[1];
    });

    return urlParametersMap;
}